/* Built In Imports */
import { Fragment, useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  Heading,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import parser from 'html-react-parser';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SimpleButton from '@shi/components/button/SimpleButton';
import SectionTitle from '@shi/components/headings/SectionTitle';
import StructuredTextParser from '@shi/Utility/StructuredTextParser';

/* Services */

/**
 * Renders the ShivangaPricing component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} ShivangaPricing component
 */

const PricingGlobal = ({ sectionContent, lang, isInPopup }) => {
  const [value, setValue] = useState('0');
  const otherWays = sectionContent?.find(el => el.fieldId == 'other-ways');
  const json_table = sectionContent?.find(
    el => el._modelApiKey == 'json_table'
  );
  const activeRadio = json_table?.data.value[value];
  const linkStyle = {
    a: {
      color: '#ca4e2a',
      textDecor: 'underline',
    },
    'a:hover': {
      color: '#dc8513',
      textDecor: 'underline',
    },
  };
  return (
    <Box
      p={
        !isInPopup
          ? { base: '60px 15px 60px', md: '70px 15px 70px' }
          : { base: '0px 5px 30px', md: '20px 15px 0px' }
      }
      w={{ base: '100%', md: '100%' }}
      background="#02093C"
    >
      <Box w={'100%'} spacing={10} align="center" justify="center">
        {sectionContent?.map((secCon, index) => {
          if (secCon._modelApiKey === 'section_title' && !isInPopup) {
            return (
              <SectionTitle
                mb={{ base: '17px', md: '40px' }}
                className="pricing-title"
                titleObj={secCon}
                key={index}
              />
            );
          }
        })}

        <Box maxW={isInPopup ? 975 : 1000} mx="auto">
          <Stack spacing={isInPopup ? 0 : 2} align="center">
            {sectionContent?.map((secCon, index) => {
              if (secCon?._modelApiKey == 'json_table') {
                const data = secCon?.data;
                return (
                  <RadioGroup
                    onChange={setValue}
                    value={value}
                    defaultValue={'0'}
                    key={nanoid()}
                  >
                    <Flex flexWrap={{ base: 'wrap', md: 'wrap' }} gap="14px">
                      {data?.value?.map((val, ind) => {
                        return (
                          <Fragment key={nanoid()}>
                            <Box
                              as="label"
                              display="block"
                              rounded="8px"
                              p={{
                                base: '27px',
                                md: isInPopup ? '20px' : '27px',
                              }}
                              height={209}
                              flex={1}
                              bg={ind == Number(value) ? '#FCF6E2' : '#fff'}
                              minW={{ base: 280, sm: 330, md: '1px' }}
                              border={
                                ind == Number(value)
                                  ? '2px solid #CA4E2A'
                                  : '2px solid transparent'
                              }
                              _hover={{
                                border: '2px solid #CA4E2A',
                                bg: '#FCF6E2',
                              }}
                              maxW={{ md: 325 }}
                            >
                              <Flex alignItems="flex-start">
                                <Radio
                                  colorScheme="orange"
                                  size="lg"
                                  value={`${ind}`}
                                  mr="10px"
                                  borderColor="#CA4E2A"
                                />
                                <Flex
                                  alignItems="flex-start"
                                  flexDir="column"
                                  width="100%"
                                >
                                  <Heading
                                    as="h3"
                                    fontSize={{
                                      base: '16px',
                                      md: '16px',
                                    }}
                                    color="#000"
                                    textAlign={{
                                      base: 'left',
                                      md: 'left',
                                    }}
                                    lineHeight="30px"
                                    fontFamily="FedraSansStd-medium"
                                  >
                                    {val.heading}
                                    <Text
                                      as="span"
                                      fontFamily="FedraSansStd-book"
                                      textAlign={{
                                        base: 'left',
                                        md: 'left',
                                      }}
                                      fontSize="12px"
                                      lineHeight="15px"
                                    >
                                      {' '}
                                      {val?.subHeading}
                                    </Text>
                                  </Heading>
                                  <Text
                                    textAlign={{
                                      base: 'left',
                                      md: 'left',
                                    }}
                                    lineHeight="17px"
                                    fontSize="12px"
                                    sx={linkStyle}
                                  >
                                    {' '}
                                    {parser(val?.subTextt)}
                                  </Text>
                                  <Text
                                    fontSize={{
                                      base: '16px',
                                      md: '16px',
                                    }}
                                    color="#CA4E2A"
                                    fontFamily="FedraSansStd-medium"
                                    textAlign={{
                                      base: 'left',
                                      md: 'left',
                                    }}
                                    lineHeight={isInPopup ? '20px' : '30px'}
                                    my={{
                                      base: '12px',
                                      md: isInPopup ? '12px' : '8px',
                                    }}
                                  >
                                    {val?.priceText}
                                  </Text>
                                  <Text
                                    fontFamily="FedraSansStd-book"
                                    fontSize={{
                                      base: '10px',
                                      md: '10px',
                                    }}
                                    textAlign={{
                                      base: 'left',
                                      md: 'left',
                                    }}
                                    lineHeight={'16px'}
                                    sx={{
                                      ul: {
                                        pl: '20px',
                                      },
                                      ...linkStyle,
                                    }}
                                    maxW={{
                                      base: 219,
                                      sm: isInPopup ? '320px' : '266px',
                                    }}
                                    mx="0"
                                    mb="30px"
                                  >
                                    {parser(val.details)}
                                  </Text>
                                </Flex>
                              </Flex>
                            </Box>
                            {/* {ind === 0 && otherWays && (
                              <Center flex="100%" width="100%">
                                <StructuredTextParser
                                  str={render(otherWays?.body)}
                                  fontFamily="FedraSansStd-medium"
                                  mt="0"
                                  bgTheme="light"
                                  textAlign={{
                                    base: 'left',
                                    md: 'left',
                                  }}
                                  color="#fff"
                                  sx={{
                                    p: {
                                      fontFamily:
                                        'FedraSansStd-medium !important',
                                      fontSize: '16px',
                                      marginBottom: '0px',
                                      marginTop: '0',
                                    },
                                  }}
                                />
                              </Center>
                            )} */}
                          </Fragment>
                        );
                      })}
                    </Flex>
                  </RadioGroup>
                );
              } else if (secCon.fieldId === 'purchase-text') {
                return (
                  <Box w="auto" mt={{ base: '30px', md: '0' }} key={nanoid()}>
                    <StructuredTextParser
                      str={render(secCon.body)}
                      fontFamily="FedraSansStd-medium"
                      // bgTheme="light"
                      my="0"
                      textAlign="center"
                      maxW="none !important"
                      className="purchase_text"
                      color="#fff"
                      lineHeight="26px"
                      mt={isInPopup ? '20px' : '30px'}
                      w="auto"
                      sx={{
                        p: {
                          fontSize: isInPopup ? '14px' : '16px',
                          margin: '0px',
                          maxWidth: 'none',
                        },
                        'ul, li': {
                          maxWidth: 'none',
                        },
                      }}
                    />
                  </Box>
                );
              } else if (secCon.fieldId === 'from-isha-life') {
                return (
                  <Box w="auto" key={nanoid()}>
                    <StructuredTextParser
                      str={render(secCon.body)}
                      fontFamily="FedraSansStd-medium"
                      // bgTheme="light"
                      textAlign="center"
                      maxW="515px"
                      className="purchase_text"
                      color="#fff"
                      mb={isInPopup ? '7px' : '10px'}
                      lineHeight="26px"
                      my="0"
                      mt="0"
                      w="auto"
                      sx={{
                        p: {
                          fontSize: '16px',
                          margin: '0px',
                          maxWidth: 'none',
                        },
                        // 'p:before': {
                        //   content: "''",
                        //   display: 'inline-block',
                        //   width: '7px',
                        //   height: '7px',
                        //   background: '#fff',
                        //   rounded: 'full',
                        //   marginRight: '15px',
                        //   marginBottom: '2px',
                        // },
                        'ul, li': {
                          maxWidth: 'none',
                        },
                      }}
                    />
                  </Box>
                );
              } else if (secCon.fieldId === 'same-pricing') {
                return (
                  <Box w="auto" key={nanoid()}>
                    <StructuredTextParser
                      str={render(secCon.body)}
                      fontFamily="FedraSansStd-medium"
                      pb="0px"
                      mb={isInPopup ? '15px' : '10px'}
                      // bgTheme="light"
                      textAlign="center"
                      maxW="none !important"
                      className="purchase_text"
                      color="#fff"
                      lineHeight="26px"
                      mt={{ base: '25px', md: isInPopup ? '8px' : '10px' }}
                      w="auto"
                      sx={{
                        p: {
                          fontSize: isInPopup ? '14px' : '16px',
                          margin: '0px',
                          maxWidth: 'none',
                        },
                        'ul, li': {
                          maxWidth: 'none',
                        },
                      }}
                    />
                  </Box>
                );
              }
            })}
          </Stack>
        </Box>
        <Box
          position="fixed"
          bottom="0"
          left="0"
          background="#00052F"
          width="100%"
          display={{ base: isInPopup ? 'block' : 'none', md: 'none' }}
          height="90px"
          pt="12px"
        >
          {sectionContent?.map((secCon, index) => {
            if (secCon._modelApiKey === 'simple_button') {
              return (
                <SimpleButton
                  style={{ ...secCon, linkUrl: activeRadio?.link }}
                  minW={{ md: '335px', base: '243px' }}
                  mb="0"
                  mt="5px"
                  fontSize="16px"
                  key={nanoid()}
                />
              );
            }
          })}
        </Box>
        <Box display={{ base: isInPopup ? 'none' : 'block', md: 'block' }}>
          {sectionContent?.map((secCon, index) => {
            if (secCon._modelApiKey === 'simple_button') {
              return (
                <SimpleButton
                  style={{ ...secCon, linkUrl: activeRadio?.link }}
                  minW={{ md: '335px', base: '243px' }}
                  mb={isInPopup ? '20px' : '0'}
                  mt="5px"
                  fontSize="16px"
                  key={nanoid()}
                />
              );
            }
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default PricingGlobal;
